var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeLatest, select, } from 'redux-saga/effects';
import { actions as questionsActions } from '../../questions';
import { runActionAfterDelay } from '../../utils/sagas';
import { getSelectedCategoryGlobalId } from '../../categories/selectors';
import { ActionTypes, actions } from './actions';
import { fetchStoreServiceId } from './requests';
export function loadStoreServiceIdSaga(_a) {
    var selectedCategoryServiceId, response, error_1;
    var _b = _a.payload, selectedStoreJrniId = _b.selectedStoreJrniId, categoryServiceId = _b.categoryServiceId, callback = _b.callback;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 7, , 9]);
                return [4 /*yield*/, select(getSelectedCategoryGlobalId)];
            case 1:
                selectedCategoryServiceId = _c.sent();
                return [4 /*yield*/, call(fetchStoreServiceId, selectedStoreJrniId, categoryServiceId || selectedCategoryServiceId)];
            case 2:
                response = _c.sent();
                return [4 /*yield*/, put(actions.loadServiceIdSuccess({
                        serviceId: response.id,
                        minAdvancePeriod: response.min_advance_period,
                        maxAdvancePeriod: response.max_advance_period,
                    }))];
            case 3:
                _c.sent();
                return [4 /*yield*/, put(questionsActions.setQuestionsGroupId(response.detail_group_id))];
            case 4:
                _c.sent();
                if (!callback) return [3 /*break*/, 6];
                return [4 /*yield*/, call(callback)];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7:
                error_1 = _c.sent();
                return [4 /*yield*/, put(actions.loadServiceIdFailure(error_1))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(ActionTypes.LOAD_SERVICE_ID, loadStoreServiceIdSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_SERVICE_ID_FAILURE, function () {
                        return runActionAfterDelay(actions.removeServiceIdError());
                    })];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
